// DateRangeFilter.js
// import { ORDER_FILTER_KEYS } from '../Filter';
import { Box, InputBase, List, ListItem, ListItemButton, useTheme } from '@mui/material';
import { tokens } from '../../../../../theme';
import { orderStateMap } from '../../../../../utils/labelColorText';
import { ORDER_FILTER_KEYS } from '../../Filter';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import cx from 'classnames'; // Importing cx from classnames
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';
import { useGetOptionsWithCountQuery } from '../../../../../newapi/pickingjob/pickingjobSlice';
import Text from '../../../../theme/text/Text';
import CheckIcon from '@mui/icons-material/Check';
import { useGetProductsSelectQuery } from '../../../../../newapi/warehouse/productSlice';
const ProductFilter = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = ORDER_FILTER_KEYS.PRODUCT.backend_key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    const [searchTerm, setSearchTerm] = useState(null);
    const [isSearchTermLongEnough, setIsSearchTermLongEnough] = useState(true);
    const { data: products } = useGetProductsSelectQuery(
        {
            searchString:searchTerm
        },
        {
            skip: !searchTerm
        }
    );

    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentState = filterObject.filter[filterKey] ?? -1;
            const updatedState = (currentState === itemState) ? -1 : itemState;
            dispatch(updateFilter({ index, id, filterKey, value: updatedState }));
        }
    };
  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            <Box
                sx={{
                    position:"sticky",
                    top:0,
                    zIndex:3,
                    width:1,
                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    pb:1,

                }}
            >
                <Box
                    sx={{
                        height:32,
                        width:1,
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        borderRadius:4,
                        color:colors.txt['primary'],
                        fontSize:14,
                        display:"flex",
                        alignItems:"center",
                    }}
                >
                    <InputBase
                        onKeyDown={(e) => {
                            if(e.key === "Enter") {
                                setIsSearchTermLongEnough(true);
                                if(e.target.value.length <3) {
                                    setIsSearchTermLongEnough(false);
                                    return;
                                }
                                setSearchTerm(e.target.value);
                            }
                        }}
                        onSubmit={(e) => {
                            setIsSearchTermLongEnough(true);
                            if(e.target.value.length <3) {
                                setIsSearchTermLongEnough(false);
                                return;
                            }
                            setSearchTerm(e.target.value);
                        }}
                        placeholder={t("search")}
                        autoFocus
                        sx={{
                            // width:1,
                            flex:1,
                            height:32,
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            borderRadius:4,
                            px:2,
                            color:colors.txt['primary'],
                            fontSize:14,
                        }}
                    />
                    {!isSearchTermLongEnough &&
                        <Box
                            sx={{
                                border:`1px solid ${colors.red[400]}`,
                                px:1,
                                background:colors.red[100],
                                color:colors.red[400],
                                borderRadius:3,
                                fontWeight:500,
                                fontSize:14,
                                mr:0.5,
                            }}
                        >
                            {t("search_term_not_long_enough")}
                        </Box>
                    }
                </Box>
            </Box>
            <List
                sx={{
                    padding:0,
                    display:"flex",
                    flexDirection:"column",
                    gap:1.5,
                }}
            >
                {products?.map((column, index) => (

                    <ListItem key={column.column + "index" + index} disablePadding 
                        onClick={() => handleStateToggle(column.id)}
                    >
                        <ListItemButton
                            className={cx({
                                active: filterObject && filterObject.filter?.[filterKey] === column.id
                            })}
                            sx={{
                                minWidth:250,
                                color:`${filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.column ? theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] : colors.txt["secondary"]}`,
                                fontWeight:`${filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.column ? 500 : 400}`,
                                display:"flex",
                                justifyContent:"flex-start",
                                alignItems:"flex-start",
                                flexDirection:"column",
                                fontSize:"14px",
                                pl:2,
                                pr:0.5,
                                // height:40,
                                borderRadius:5,

                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                "&.active" : {
                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],

                                }
                            }}
                        >
                            <Text bold>{column.sku}</Text>
                            <Text italic fontSize={12}>{column.description}</Text>
                        </ListItemButton>
                    </ListItem>
                    
                ))}
            </List>
           
        </Box>
    );
};

export default ProductFilter;